export const getAccountsIds = (permissions) => {
    var _a, _b, _c;
    return [...(((_a = permissions.read) === null || _a === void 0 ? void 0 : _a.accountIds) || []), ...(((_b = permissions.modify) === null || _b === void 0 ? void 0 : _b.accountIds) || []), ...(((_c = permissions.write) === null || _c === void 0 ? void 0 : _c.accountIds) || [])];
};
